export const quizQuestions = [
  {
    id: "question15",
    videoId: "video15",
    topic: "Driving",
    question: "A vehicle is approaching on a crosswalk:",
    options: [
      "The car has the right of way",
      "The pedestrians has the right of way",
      "Neither the car nor the pedestrian has the right of way",
    ],
    correctAnswer: "The pedestrians has the right of way",
    descriptionTitle: "Changing Lanes",
    description1:
      "Traffic light warning signs are used to alert drivers to the presence of a traffic signal (usually a traffic light) ahead and to provide advance notice of its operation. These signs serve as a visual cue to drivers, giving them time to slow down, anticipate the upcoming traffic signal, and respond safely and appropriately to the changing traffic conditions. It's important for drivers to be attentive and follow these signs to ensure safe and orderly traffic flow.",
  },
];
